import React, { useEffect, useState } from "react"
import { useNavigation } from "@react-navigation/native"
import { Text, IconButton, Provider as PaperProvider, Modal, Portal } from "react-native-paper"
import { View, TouchableOpacity, ImageBackground, StyleSheet, Pressable } from "react-native"
import { avatarImageString, profileName, header as heading, headerText, stopExecutions, registerModal, } from "./StockAwareTempData"
import { MyButton } from "./buttonsAndControls"
import Registration from "./registration"

const darkColour='#2a2d3e'

export const Header = () => {
	const navigation = useNavigation()
  const profile = profileName
  const whichAvatar = avatarImageString.charAt(20) + avatarImageString.charAt(21)
	const [modalVisible, setModalVisible] = useState(false)
	const [profileHovered, setProfileHovered] = useState(false);
	const [settingsHovered, setSettingsHovered] = useState(false);
	const [logoutHovered, setLogoutHovered] = useState(false);
	const [header, setHeader] = useState(' ')
	const [showReg, setShowReg] = useState(true)
	const [resultReceived, setResultReceived] = useState('');
  const [result, setResult] = useState('');

	useEffect(() => {
		setHeader(headerText)
	}, [headerText]);

	const handleLogout = () => {
		stopExecutions(undefined)
		navigation.navigate('LogIn' as never) 
	}

	const handleRegister = () => {
		registerModal(true)
	}

	const dashboardPressed = () => {
		stopExecutions(false)
		setTimeout(() => {
			navigation.navigate('Dashboard' as never)
		}, 100);
	
	}
		return(
			<View style={stylesBox.parent}>
			<View style={{marginLeft:10, marginTop: 5, flex:1}}>
				<MyButton btnText='Dashboard' 
				btnBorClr='white' 
				btnBorWdt={0} 
				btnColor={darkColour} 
				btnHeight={40} 
				btnTxtClr='white' 
				btnFontSize={17}
				btnWidth={200}
				btnBorRadius={10}
				btnPadding={9}
				hndClicked={dashboardPressed}
				
				/>
			</View>
			<View style={{flex:1, alignContent:'center', justifyContent:'center'}}>
			<Text style={{...stylesBox.mediumText, color: darkColour, fontSize:20, alignSelf:'center', fontWeight:'600'}}>
				{header}
			</Text>
			</View>
			<View style={{flexDirection:'column', flex:1}}>
				<View style={{flexDirection:'row', alignSelf:'flex-end'}}>
					<Text style={{...stylesBox.mediumText, marginRight:10}}>
						{profile}
					</Text>
					
					<View style={stylesBox.imageBox}>
						<TouchableOpacity onPress={() => {setModalVisible(((prev) => !prev)); setResultReceived('')}} 
						style={{...stylesBox.imageBox, borderWidth:1}}>
							<ImageBackground
								source={
									whichAvatar === '1-' ? require('./src_Files/Avatars/1-black-shade-girl.png')
									: whichAvatar === '2-' ? require('./src_Files/Avatars/2-blue-eyes-male.png')
									: whichAvatar === '3-' ? require('./src_Files/Avatars/3-boy-on-hood.png')
									: whichAvatar === '4-' ? require('./src_Files/Avatars/4-eye-glass-male.png')
									: whichAvatar === '5-' ? require('./src_Files/Avatars/5-faceless-black-girl.png')
									: whichAvatar === '6-' ? require('./src_Files/Avatars/6-faceless-black-hair.png')
									: whichAvatar === '7-' ? require('./src_Files/Avatars/7-faceless-black-lady.png')
									: whichAvatar === '8-' ? require('./src_Files/Avatars/8-faceless-female.gif')
									: whichAvatar === '9-' ? require('./src_Files/Avatars/9-faceless-girl.png')
									: whichAvatar === '10' ? require('./src_Files/Avatars/10-faceless-g-laughing.png')
									: whichAvatar === '11' ? require('./src_Files/Avatars/11-faceless-lady.png')
									: whichAvatar === '12' ? require('./src_Files/Avatars/12-faceless-male.gif')
									: whichAvatar === '13' ? require('./src_Files/Avatars/13-fam-guy-Brian.png')
									: whichAvatar === '14' ? require('./src_Files/Avatars/14-man-laughing.png')
									: whichAvatar === '15' ? require('./src_Files/Avatars/15-office-man.png')
									: whichAvatar === '16' ? require('./src_Files/Avatars/16-young-boy.png')
									: whichAvatar === '17' ? require('./src_Files/Avatars/17-young-girl.png')
									: whichAvatar === '18' ? require('./src_Files/Avatars/18-young-white-boy.png')
									: require('./src_Files/Avatars/14-man-laughing.png')
									}
								style={{ flex: 1, }}
								resizeMode='cover' 
								imageStyle={{opacity:1}}
							/>  
						</TouchableOpacity>
					</View>
						
				</View>
					<PaperProvider>
						<Portal>
							<Modal visible={modalVisible} onDismiss={()=> setModalVisible(((prev) => !prev))} contentContainerStyle = {stylesBox.menuModal}>
								<View style={{flexDirection:'column', height:120, width:200, borderRadius:10,}}>
									<TouchableOpacity style={[stylesBox.button, { backgroundColor: profileHovered ? '#F1F1F0' : 'transparent' }]}>
										<Pressable onHoverIn={()=> setProfileHovered(true)} onHoverOut={()=> setProfileHovered(false)} style={stylesBox.buttonContent}>
											<IconButton icon={'account-circle'} size={25} focusable={false} iconColor={darkColour} style={stylesBox.buttonIcon}/>
											<Text style={stylesBox.buttonText}>
												Profile
											</Text>
										</Pressable>
									</TouchableOpacity>
									<TouchableOpacity style={[stylesBox.button, { backgroundColor: settingsHovered ? '#F1F1F0' : 'transparent' }]}>
										<Pressable onHoverIn={()=> setSettingsHovered(true)} onHoverOut={()=> setSettingsHovered(false)} onPress={handleRegister}
										style={stylesBox.buttonContent}>
											<IconButton icon={'cog-outline'} size={25} focusable={false} iconColor={darkColour} style={stylesBox.buttonIcon}/>
											<Text style={stylesBox.buttonText}>
												Settings
											</Text>
										</Pressable>
									</TouchableOpacity>
									<TouchableOpacity style={[stylesBox.button, { backgroundColor: logoutHovered ? '#F1F1F0' : 'transparent' }]}>
										<Pressable onHoverIn={()=> setLogoutHovered(true)} onHoverOut={()=> setLogoutHovered(false)} onPress={handleLogout}
										style={stylesBox.buttonContent}>
											<IconButton icon={'logout-variant'} size={25} focusable={false} iconColor={darkColour} style={stylesBox.buttonIcon}/>
											<Text style={stylesBox.buttonText}>
												Logout
											</Text>
										</Pressable>
									</TouchableOpacity>
								</View>
							</Modal>
						</Portal>
					</PaperProvider>
			</View>
		</View>
  )
}

const DropDownP = () => {
	const [isPressed, setIsPressed] = useState(false);
  	const [profileHovered, setProfileHovered] = useState(false);
	const [settingsHovered, setSettingsHovered] = useState(false);
	const [logoutHovered, setLogoutHovered] = useState(false);
	const [modalVisible, setModalVisible] = useState(false)

  const handlePress = () => {
    // Handle button press
  };

 
	return(
			<PaperProvider>
				<Portal>
					<Modal visible={modalVisible} onDismiss={()=> setModalVisible(((prev) => !prev))}>
						<View style={{flexDirection:'column', height:120, width:200, borderRadius:10, borderWidth:1, backgroundColor:'white'}}>
							<TouchableOpacity style={[stylesBox.button, { backgroundColor: profileHovered ? '#EDECEB' : 'transparent' }]}>
								<Pressable onHoverIn={()=> setProfileHovered(true)} onHoverOut={()=> setProfileHovered(false)} style={stylesBox.buttonContent}>
									<IconButton icon={'account-circle'} size={25} focusable={false} iconColor={darkColour} style={stylesBox.buttonIcon}/>
									<Text style={stylesBox.buttonText}>
										Profile
									</Text>
								</Pressable>
							</TouchableOpacity>
							<TouchableOpacity style={[stylesBox.button, { backgroundColor: settingsHovered ? '#EDECEB' : 'transparent' }]}>
								<Pressable onHoverIn={()=> setSettingsHovered(true)} onHoverOut={()=> setSettingsHovered(false)} style={stylesBox.buttonContent}>
									<IconButton icon={'cog-outline'} size={25} focusable={false} iconColor={darkColour} style={stylesBox.buttonIcon}/>
									<Text style={stylesBox.buttonText}>
										Settings
									</Text>
								</Pressable>
							</TouchableOpacity>
							<TouchableOpacity style={[stylesBox.button, { backgroundColor: logoutHovered ? '#EDECEB' : 'transparent' }]}>
								<Pressable onHoverIn={()=> setLogoutHovered(true)} onHoverOut={()=> setLogoutHovered(false)} style={stylesBox.buttonContent}>
									<IconButton icon={'logout-variant'} size={25} focusable={false} iconColor={darkColour} style={stylesBox.buttonIcon}/>
									<Text style={stylesBox.buttonText}>
										Logout
									</Text>
								</Pressable>
							</TouchableOpacity>
						</View>
					</Modal>
				</Portal>
			</PaperProvider>
	)
}

const stylesBox = StyleSheet.create ({
	parent: {
		height:50, 
		width: 2000, 
		flexDirection:'row', 
		backgroundColor:'white'
	},
	menuModal: {
		height:130, 
		width:202, 
		backgroundColor:'white', 
		borderWidth:1, 
		borderColor: 'gray', 
		borderRadius: 0, 
		shadowColor: 'gray', 
		shadowOffset: { width: 2,  height: 2 },
		top:0,
		right: 10, 
		position: 'absolute'
	},
  imageBox: {
    width:50, 
		height:50, 
		backgroundColor:'transparent', 
		borderRadius:50, 
		borderWidth:0, 
		marginRight:10
  },
  iconButton: {
		width:40, 
		height:40, 
		borderRadius:50, 
		backgroundColor:'black', 
		alignContent:'center', 
		alignSelf:'center', 
		marginLeft:10, 
		marginRight:10
  },
  bigText: {
    color:'#2A6AA7', 
    fontFamily:'century gothic', 
    fontSize:30, 
    fontWeight:'normal', 
    textAlign:'center',
  },
  mediumText: {
    color: darkColour, 
    fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'500', 
    textAlign:'center',
    marginTop:5,
		verticalAlign:'middle', 
		alignSelf:'center'
    },
		button: {
			height: 40,
			backgroundColor: 'transparent',
			justifyContent: 'center'
		},
		buttonContent: {
			flexDirection: 'row',
			alignItems: 'center',
			padding:0
		},
		buttonIcon: {
			justifyContent: 'center',
			alignSelf: 'center',
		},
		buttonText: {
			color: darkColour, 
			fontFamily:'century gothic', 
			fontSize:16, 
			fontWeight:'500', 
			textAlign:'center',
			marginTop:0,
			verticalAlign:'middle', 
			alignSelf:'center',
			paddingLeft: 10,
		},
})

//export default Header